export enum PipelineDetailedTabTypes {
    all = 'All',
    ioi = 'IOIs',
    notes = 'Notes',
}
